export enum UploadStatus {
  SUCCESS = 0,
  UPLOADING = 1,
  FAILED = 2,
  PROCESSING = 3,
}

export interface XFile {
  create_time: string
  eta: number
  failed_info?: {
    reason: number
    hint: number
    detail: string
  }
  filename: string
  filesize: number
  id: number
  media_id: number
  media_type: number
  percent: number
  resource_type: number
  update_time: string
  upload_secret_id: string
  upload_status: UploadStatus
  upload_type: number
  user_id: number
}

export enum UploadFailedStatus {
  PAGE_REFRESH = 6, // 页面刷新
  CALLBACK_FAILED = 7, // 回调失败
  SDK_UPLOAD_ERROR = 8, // SDK上传错误
  CONNECTION_ERROR = 9, // 连接超时
}

export interface CancelUploadData {
  upload_secret_id: string
  failed_hint?: UploadFailedStatus
  delete_data?: boolean
}
